var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: _vm.title,
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          isPrimary: _vm.isPrimary,
          icon: "attachment",
          isLoading: _vm.isLoading,
        },
        on: { onClicked: (val) => _vm.$emit(val) },
      },
      "Section",
      _vm.$attrs,
      false
    ),
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.attachmentList,
          "item-key": "id",
          "rows-per-page-items": [15, 25, 50, 100],
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._formatJavascriptDate({
                          date: props.item.dateTimeUploaded,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " + _vm._s(props.item.fileName) + "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.activityTypeList,
                          idKey: "id",
                          idValue:
                            (props.item.activityList[0] &&
                              props.item.activityList[0].typeId) ||
                            -1,
                          propertyKey: "name",
                          emptyText: " ",
                        })
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm._formatJavascriptDate({
                          date:
                            (props.item.activityList[0] &&
                              props.item.activityList[0].dateTimePerformedOn) ||
                            null,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.userList,
                          idKey: "id",
                          idValue: props.item.userIdUploadedBy,
                          propertyKey: "name",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _vm.showUnlinkButton
                      ? _c("ControlButton", {
                          attrs: {
                            text: "Unlink",
                            icon: "link_off",
                            iconColor: "error",
                            disabled: _vm.isLoading,
                          },
                          on: {
                            onClicked: function ($event) {
                              return _vm.$emit("onClickUnlinkAttachment", {
                                attachmentId: props.item.id,
                                fileName: props.item.fileName,
                              })
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ControlButton", {
                      attrs: {
                        text: "View",
                        depressed: "",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        onClicked: function ($event) {
                          return _vm.$emit("onClickViewAttachment", {
                            attachmentId: props.item.id,
                          })
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }